const getInitLetters = (username: string) => {
  if (!username) return 'LH';
  const usernameArray = username.split(' ');
  const firstLetters = usernameArray.map(item => item.charAt(0).toUpperCase());
  return usernameArray.length <= 1 ? firstLetters[0] : `${firstLetters[0]}${firstLetters[1]}`;
};

export default getInitLetters;
